import { utilizationApi as api } from './utilizationApi';
export const addTagTypes = ['matching'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes
  })
  .injectEndpoints({
    endpoints: build => ({
      matchingUtilizationTableauAvailableTrend: build.mutation<
        MatchingUtilizationTableauAvailableTrendApiResponse,
        MatchingUtilizationTableauAvailableTrendApiArg
      >({
        query: queryArg => ({
          url: `/matching/utilization_tableau/available_trend/`,
          method: 'POST',
          body: queryArg.body
        }),
        invalidatesTags: ['matching']
      }),
      matchingUtilizationTableauGetCountries: build.mutation<
        MatchingUtilizationTableauGetCountriesApiResponse,
        MatchingUtilizationTableauGetCountriesApiArg
      >({
        query: queryArg => ({
          url: `/matching/utilization_tableau/get_countries/`,
          method: 'POST',
          body: queryArg.body
        }),
        invalidatesTags: ['matching']
      }),
      matchingUtilizationTableauGetDistricts: build.mutation<
        MatchingUtilizationTableauGetDistrictsApiResponse,
        MatchingUtilizationTableauGetDistrictsApiArg
      >({
        query: queryArg => ({
          url: `/matching/utilization_tableau/get_districts/`,
          method: 'POST',
          body: queryArg.body
        }),
        invalidatesTags: ['matching']
      }),
      matchingUtilizationTableauGetStates: build.mutation<
        MatchingUtilizationTableauGetStatesApiResponse,
        MatchingUtilizationTableauGetStatesApiArg
      >({
        query: queryArg => ({
          url: `/matching/utilization_tableau/get_states/`,
          method: 'POST',
          body: queryArg.body
        }),
        invalidatesTags: ['matching']
      }),
      matchingUtilizationTableauGetWeek: build.mutation<
        MatchingUtilizationTableauGetWeekApiResponse,
        MatchingUtilizationTableauGetWeekApiArg
      >({
        query: queryArg => ({
          url: `/matching/utilization_tableau/get_week/`,
          method: 'POST',
          body: queryArg.body
        }),
        invalidatesTags: ['matching']
      }),
      matchingUtilizationTableauGetZipcode: build.mutation<
        MatchingUtilizationTableauGetZipcodeApiResponse,
        MatchingUtilizationTableauGetZipcodeApiArg
      >({
        query: queryArg => ({
          url: `/matching/utilization_tableau/get_zipcode/`,
          method: 'POST',
          body: queryArg.body
        }),
        invalidatesTags: ['matching']
      }),
      matchingUtilizationTableauOutstandingRequests: build.mutation<
        MatchingUtilizationTableauOutstandingRequestsApiResponse,
        MatchingUtilizationTableauOutstandingRequestsApiArg
      >({
        query: queryArg => ({
          url: `/matching/utilization_tableau/outstanding_requests/`,
          method: 'POST',
          body: queryArg.body
        }),
        invalidatesTags: ['matching']
      }),
      matchingUtilizationTableauOutstandingRequestsDetails: build.mutation<
        MatchingUtilizationTableauOutstandingRequestsDetailsApiResponse,
        MatchingUtilizationTableauOutstandingRequestsDetailsApiArg
      >({
        query: queryArg => ({
          url: `/matching/utilization_tableau/outstanding_requests_details/`,
          method: 'POST',
          body: queryArg.body
        }),
        invalidatesTags: ['matching']
      }),
      matchingUtilizationTableauUtilizedByDistrict: build.mutation<
        MatchingUtilizationTableauUtilizedByDistrictApiResponse,
        MatchingUtilizationTableauUtilizedByDistrictApiArg
      >({
        query: queryArg => ({
          url: `/matching/utilization_tableau/utilized_by_district/`,
          method: 'POST',
          body: queryArg.body
        }),
        invalidatesTags: ['matching']
      }),
      matchingUtilizationTableauUtilizedRateTrend: build.mutation<
        MatchingUtilizationTableauUtilizedRateTrendApiResponse,
        MatchingUtilizationTableauUtilizedRateTrendApiArg
      >({
        query: queryArg => ({
          url: `/matching/utilization_tableau/utilized_rate_trend/`,
          method: 'POST',
          body: queryArg.body
        }),
        invalidatesTags: ['matching']
      }),
      matchingUtilizationTableauUtilizedTrends: build.mutation<
        MatchingUtilizationTableauUtilizedTrendsApiResponse,
        MatchingUtilizationTableauUtilizedTrendsApiArg
      >({
        query: queryArg => ({
          url: `/matching/utilization_tableau/utilized_trends/`,
          method: 'POST',
          body: queryArg.body
        }),
        invalidatesTags: ['matching']
      }),
      matchingUtilizationTableauUtilizedUnutilized: build.mutation<
        MatchingUtilizationTableauUtilizedUnutilizedApiResponse,
        MatchingUtilizationTableauUtilizedUnutilizedApiArg
      >({
        query: queryArg => ({
          url: `/matching/utilization_tableau/utilized_unutilized/`,
          method: 'POST',
          body: queryArg.body
        }),
        invalidatesTags: ['matching']
      })
    }),
    overrideExisting: false
  });
export { injectedRtkApi as enhancedApi };
export type MatchingUtilizationTableauAvailableTrendApiResponse =
  /** status 200 Custom Response */ {
    count?: number;
    next?: string | null;
    previous?: string | null;
    results: UtilizationSerializerTableau[];
    ok?: boolean;
    message?: {
      text?: string | null;
      code?: number;
      args?: object | null;
    };
  };
export type MatchingUtilizationTableauAvailableTrendApiArg = {
  body: {
    /** Start date (YYYY-MM-DD) */
    start_date?: string;
    /** End date (YYYY-MM-DD) */
    end_date?: string;
    /** Country UUID(s) */
    countryId?: string[];
    /** State UUID(s) */
    stateId?: string[];
    /** District UUID(s) */
    districtId?: string[];
    /** Week start dates (YYYY-MM-DD) */
    weeks?: string[];
    /** Zip codes */
    zip?: string[];
    /** Tab Type */
    tab?: string[];
  };
};
export type MatchingUtilizationTableauGetCountriesApiResponse =
  /** status 200 Custom Response */ {
    count?: number;
    next?: string | null;
    previous?: string | null;
    results: UtilizationSerializerTableau[];
    ok?: boolean;
    message?: {
      text?: string | null;
      code?: number;
      args?: object | null;
    };
  };
export type MatchingUtilizationTableauGetCountriesApiArg = {
  body: {
    /** Start date (YYYY-MM-DD) */
    start_date?: string;
    /** End date (YYYY-MM-DD) */
    end_date?: string;
    /** Country UUID(s) */
    countryId?: string[];
    /** State UUID(s) */
    stateId?: string[];
    /** District UUID(s) */
    districtId?: string[];
    /** Week start dates (YYYY-MM-DD) */
    weeks?: string[];
    /** Zip codes */
    zip?: string[];
    /** Tab Type */
    tab?: string;
  };
};
export type MatchingUtilizationTableauGetDistrictsApiResponse =
  /** status 200 Custom Response */ {
    count?: number;
    next?: string | null;
    previous?: string | null;
    results: UtilizationSerializerTableau[];
    ok?: boolean;
    message?: {
      text?: string | null;
      code?: number;
      args?: object | null;
    };
  };
export type MatchingUtilizationTableauGetDistrictsApiArg = {
  body: {
    /** Start date (YYYY-MM-DD) */
    start_date?: string;
    /** End date (YYYY-MM-DD) */
    end_date?: string;
    /** Country UUID(s) */
    countryId?: string[];
    /** State UUID(s) */
    stateId?: string[];
    /** District UUID(s) */
    districtId?: string[];
    /** Week start dates (YYYY-MM-DD) */
    weeks?: string[];
    /** Zip codes */
    zip?: string[];
    /** Tab Type */
    tab?: string;
  };
};
export type MatchingUtilizationTableauGetStatesApiResponse =
  /** status 200 Custom Response */ {
    count?: number;
    next?: string | null;
    previous?: string | null;
    results: UtilizationSerializerTableau[];
    ok?: boolean;
    message?: {
      text?: string | null;
      code?: number;
      args?: object | null;
    };
  };
export type MatchingUtilizationTableauGetStatesApiArg = {
  body: {
    /** Start date (YYYY-MM-DD) */
    start_date?: string;
    /** End date (YYYY-MM-DD) */
    end_date?: string;
    /** Country UUID(s) */
    countryId?: string[];
    /** State UUID(s) */
    stateId?: string[];
    /** District UUID(s) */
    districtId?: string[];
    /** Week start dates (YYYY-MM-DD) */
    weeks?: string[];
    /** Zip codes */
    zip?: string[];
    /** Tab Type */
    tab?: string;
  };
};
export type MatchingUtilizationTableauGetWeekApiResponse =
  /** status 200 Custom Response */ {
    count?: number;
    next?: string | null;
    previous?: string | null;
    results: UtilizationSerializerTableau[];
    ok?: boolean;
    message?: {
      text?: string | null;
      code?: number;
      args?: object | null;
    };
  };
export type MatchingUtilizationTableauGetWeekApiArg = {
  body: {
    /** Start date (YYYY-MM-DD) */
    start_date?: string;
    /** End date (YYYY-MM-DD) */
    end_date?: string;
  };
};
export type MatchingUtilizationTableauGetZipcodeApiResponse =
  /** status 200 Custom Response */ {
    count?: number;
    next?: string | null;
    previous?: string | null;
    results: UtilizationSerializerTableau[];
    ok?: boolean;
    message?: {
      text?: string | null;
      code?: number;
      args?: object | null;
    };
  };
export type MatchingUtilizationTableauGetZipcodeApiArg = {
  body: {
    /** Start date (YYYY-MM-DD) */
    start_date?: string;
    /** End date (YYYY-MM-DD) */
    end_date?: string;
    /** Country UUID(s) */
    countryId?: string[];
    /** State UUID(s) */
    stateId?: string[];
    /** District UUID(s) */
    districtId?: string[];
    /** Week start dates (YYYY-MM-DD) */
    weeks?: string[];
    /** Zip codes */
    zip?: string[];
    /** Tab Type */
    tab?: string;
  };
};
export type MatchingUtilizationTableauOutstandingRequestsApiResponse =
  /** status 200 Custom Response */ {
    count?: number;
    next?: string | null;
    previous?: string | null;
    results: UtilizationSerializerTableau[];
    ok?: boolean;
    message?: {
      text?: string | null;
      code?: number;
      args?: object | null;
    };
  };
export type MatchingUtilizationTableauOutstandingRequestsApiArg = {
  body: {
    /** Start date (YYYY-MM-DD) */
    start_date?: string;
    /** End date (YYYY-MM-DD) */
    end_date?: string;
    /** Country UUID(s) */
    countryId?: string[];
    /** State UUID(s) */
    stateId?: string[];
    /** District UUID(s) */
    districtId?: string[];
    /** Week start dates (YYYY-MM-DD) */
    weeks?: string[];
    /** Zip codes */
    zip?: string[];
    /** Tab Type */
    tab?: string;
    /** Number of records to return (default: 50) */
    limit?: number;
    /** Number of records to skip (default: 0) */
    offset?: number;
  };
};
export type MatchingUtilizationTableauOutstandingRequestsDetailsApiResponse =
  /** status 200 Custom Response */ {
    count?: number;
    next?: string | null;
    previous?: string | null;
    results: UtilizationSerializerTableau[];
    ok?: boolean;
    message?: {
      text?: string | null;
      code?: number;
      args?: object | null;
    };
  };
export type MatchingUtilizationTableauOutstandingRequestsDetailsApiArg = {
  body: {
    /** Start date (YYYY-MM-DD) */
    start_date?: string;
    /** End date (YYYY-MM-DD) */
    end_date?: string;
    /** Country UUID(s) */
    countryId?: string[];
    /** State UUID(s) */
    stateId?: string[];
    /** District UUID(s) */
    districtId?: string[];
    /** Week start dates (YYYY-MM-DD) */
    weeks?: string[];
    /** Zip codes */
    zip?: string[];
    /** Tab Type */
    tab?: string[];
  };
};
export type MatchingUtilizationTableauUtilizedByDistrictApiResponse =
  /** status 200 Custom Response */ {
    count?: number;
    next?: string | null;
    previous?: string | null;
    results: UtilizationSerializerTableau[];
    ok?: boolean;
    message?: {
      text?: string | null;
      code?: number;
      args?: object | null;
    };
  };
export type MatchingUtilizationTableauUtilizedByDistrictApiArg = {
  body: {
    /** Start date (YYYY-MM-DD) */
    start_date?: string;
    /** End date (YYYY-MM-DD) */
    end_date?: string;
    /** Country UUID(s) */
    countryId?: string[];
    /** State UUID(s) */
    stateId?: string[];
    /** District UUID(s) */
    districtId?: string[];
    /** Week start dates (YYYY-MM-DD) */
    weeks?: string[];
    /** Zip codes */
    zip?: string[];
    /** Tab Type */
    tab?: string[];
  };
};
export type MatchingUtilizationTableauUtilizedRateTrendApiResponse =
  /** status 200 Custom Response */ {
    count?: number;
    next?: string | null;
    previous?: string | null;
    results: UtilizationSerializerTableau[];
    ok?: boolean;
    message?: {
      text?: string | null;
      code?: number;
      args?: object | null;
    };
  };
export type MatchingUtilizationTableauUtilizedRateTrendApiArg = {
  body: {
    /** Start date (YYYY-MM-DD) */
    start_date?: string;
    /** End date (YYYY-MM-DD) */
    end_date?: string;
    /** Country UUID(s) */
    countryId?: string[];
    /** State UUID(s) */
    stateId?: string[];
    /** District UUID(s) */
    districtId?: string[];
    /** Week start dates (YYYY-MM-DD) */
    weeks?: string[];
    /** Zip codes */
    zip?: string[];
    /** Tab Type */
    tab?: string[];
  };
};
export type MatchingUtilizationTableauUtilizedTrendsApiResponse =
  /** status 200 Custom Response */ {
    count?: number;
    next?: string | null;
    previous?: string | null;
    results: UtilizationSerializerTableau[];
    ok?: boolean;
    message?: {
      text?: string | null;
      code?: number;
      args?: object | null;
    };
  };
export type MatchingUtilizationTableauUtilizedTrendsApiArg = {
  body: {
    /** Start date (YYYY-MM-DD) */
    start_date?: string;
    /** End date (YYYY-MM-DD) */
    end_date?: string;
    /** Country UUID(s) */
    countryId?: string[];
    /** State UUID(s) */
    stateId?: string[];
    /** District UUID(s) */
    districtId?: string[];
    /** Week start dates (YYYY-MM-DD) */
    weeks?: string[];
    /** Zip codes */
    zip?: string[];
    /** Tab Type */
    tab?: string[];
  };
};
export type MatchingUtilizationTableauUtilizedUnutilizedApiResponse =
  /** status 200 Custom Response */ {
    count?: number;
    next?: string | null;
    previous?: string | null;
    results: UtilizationSerializerTableau[];
    ok?: boolean;
    message?: {
      text?: string | null;
      code?: number;
      args?: object | null;
    };
  };
export type MatchingUtilizationTableauUtilizedUnutilizedApiArg = {
  body: {
    /** Start date (YYYY-MM-DD) */
    start_date?: string;
    /** End date (YYYY-MM-DD) */
    end_date?: string;
    /** Country UUID(s) */
    countryId?: string[];
    /** State UUID(s) */
    stateId?: string[];
    /** District UUID(s) */
    districtId?: string[];
    /** Week start dates (YYYY-MM-DD) */
    weeks?: string[];
    /** Zip codes */
    zip?: string[];
    /** Tab Type */
    tab?: string[];
  };
};
export type UtilizationSerializerTableau = {
  cb_week1date: string;
  available_chefs: number;
};
export const {
  useMatchingUtilizationTableauAvailableTrendMutation,
  useMatchingUtilizationTableauGetCountriesMutation,
  useMatchingUtilizationTableauGetDistrictsMutation,
  useMatchingUtilizationTableauGetStatesMutation,
  useMatchingUtilizationTableauGetWeekMutation,
  useMatchingUtilizationTableauGetZipcodeMutation,
  useMatchingUtilizationTableauOutstandingRequestsMutation,
  useMatchingUtilizationTableauOutstandingRequestsDetailsMutation,
  useMatchingUtilizationTableauUtilizedByDistrictMutation,
  useMatchingUtilizationTableauUtilizedRateTrendMutation,
  useMatchingUtilizationTableauUtilizedTrendsMutation,
  useMatchingUtilizationTableauUtilizedUnutilizedMutation
} = injectedRtkApi;
